import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import * as moment from 'moment';
import { EventService } from '../../services/event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../../core/services/storage.service';
import { Constants } from '../../../../core/utils/constants';
import Banner from '../../../../core/models/banner';
import TicketType from '../../../../core/models/ticket.type';
import { TicketStatus } from '../../../../core/models/ticket.status';
import { UtilService } from '../../../../core/services/util.service';
import { BaseEventComponent } from '../../components/base-event/base-event.component';
import { ResponseTicketTypeOrGroupedByDate } from '../../services/ticket.service';
import { lastValueFrom, Subscription } from 'rxjs';
import { AnalitycsService } from '../../../../core/services/analitycs.service';
import { DetailService } from './services/detail.service';
import { LoadingComponent } from '../../../../core/components/loading/loading.component';
import { Fancybox } from '@fancyapps/ui';
import { Product } from 'src/app/core/types/product.type';
import {
  CheckoutSessionErrorResponse,
  CheckoutSessionService,
  CheckoutSessionStartResponse,
} from '../../services/checkout-session.service';
import { CheckoutSessionCode } from 'src/app/core/enums/checkout-session-code.enum';
import { MetaPixelService } from '../../services/meta-pixel.service';
import { MetaPixelEvent } from 'src/app/core/enums/metaPixelEvent.enum';
import { GoogleTagManagerService } from '../../services/google-tag-manager.service';
import { GtmEvent } from 'src/app/core/enums/gtmEvent.enum';
import { getPlaces } from 'src/app/core/functions/getPlaces';
import { getSoonerDate } from 'src/app/core/functions/getSoonerDate';
import Swal from 'sweetalert2';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
  providers: [DetailService],
})
export class DetailComponent extends BaseEventComponent implements OnInit {
  @ViewChild(LoadingComponent) loadingComponent!: LoadingComponent;
  @ViewChild('close_modal') closeModalBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('openEmailFormBtn')
  openEmailFormBtn!: ElementRef<HTMLButtonElement>;

  public isOpen = false;
  public totalAmount: number = 0;
  public selectedTicketsQuantity = 0;
  public selectedTicketTypeList: TicketType[] = [];
  public proceeding: boolean = false;
  public copyMessage = 'Copiar';
  public copyIcon = 'content_copy';
  public soonerTTDate = '';
  public soonerTTs: TicketType[] = [];
  public isOpenTicketsSelection = true;
  public showDonationModal = false;
  public donationTicketType?: TicketType;
  public initialDonationQty = 1;

  sendEmailForm = this.fb.group({
    email: ['', [Validators.email, Validators.required]],
  });

  private refreshSubscription?: Subscription;

  get emailInvalid() {
    const control = this.sendEmailForm.controls.email;

    const result = control.errors && control.errors['email'];

    return result;
  }

  get actionText() {
    const selectedTicketTypes = this.getSelectedTicketTypes()
    const isFree = selectedTicketTypes.every((tt) => !tt.price);

    if (!selectedTicketTypes.length) {
      return 'Seleccionar entradas';
    } else if (isFree) {
      return 'Obtener gratis';
    } else {
      return 'Comprar ahora';
    }
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private utilService: UtilService,
    private readonly metaPixelService: MetaPixelService,
    private readonly gtmService: GoogleTagManagerService,
    eventService: EventService,
    route: ActivatedRoute,
    localStorageService: StorageService,
    private analyticsService: AnalitycsService,
    private detailService: DetailService,
    private checkoutSessionService: CheckoutSessionService,
    private zone: NgZone
  ) {
    super(eventService, localStorageService, route);
  }

  ngOnInit(): void {
    this.setProducts();

    // TEMPORARY: Force open donation modal for testing
    // this.donationTicketType = {
    //   id: 999,
    //   name: 'Donación de Prueba',
    //   capacity: 100,
    //   lefts: 100,
    //   isSeat: false,
    //   active: true,
    //   price: 10,
    //   status: 'available',
    //   prefixes: '',
    //   tickets: [],
    //   rows_trackers: [],
    //   min_tickets_per_order: 1,
    //   max_tickets_per_order: 10,
    //   start_on: '',
    //   place: '',
    //   comment: '',
    //   link: '',
    //   isFree: false,
    //   is_donation: true
    // };
    // setTimeout(() => {
    //   this.showDonationModal = true;
    // }, 1000);
  }

  get places() {
    if (!this.event) return ['cargando...'];
    return getPlaces(this.event, this.getSelectedTicketTypes());
  }

  get eventUrl() {
    return window.location.href;
  }

  get soonerDate() {
    const selectedTicketTypes = this.getSelectedTicketTypes();
    return getSoonerDate(selectedTicketTypes, this.event?.startAt);
  }

  public isThreeDMap() {
    return Object.values(this.ticketTypeList).some((tt: any) => tt.block_id);
  }

  public openEmailForm() {
    this.openEmailFormBtn.nativeElement.click();
  }

  public closeEmailForm() {
    this.zone.run(() => {
      this.isOpenTicketsSelection = true;
      this.closeModalBtn.nativeElement.click();
    });
  }

  public handleEmailSubmit() {
    const email = this.sendEmailForm.value.email;
    this.proceedToCheckout(email || '');
  }

  override onInit(): void {
    if (this.event?.pixelId) {
      this.metaPixelService.insertScript(
        this.event.pixelId,
        MetaPixelEvent.VIEW_CONTENT
      );
    }
    if (this.event?.gtmId) {
      this.gtmService.insertScript(this.event.gtmId);
      this.gtmService.pushEvent(GtmEvent.VIEW_ITEM, {
        item_id: this.event.id,
        item_name: this.event.name,
      });
    }
    this.proceeding = false;
    this.totalAmount = 0;
    this.selectedTicketTypeList = [];

    this.banners = this.getBanners();

    this.refreshSubscription =
      this.detailService.onRefreshTicketTypes.subscribe(
        this.refreshTicketTypes.bind(this)
      );

    this.eventService.ticketService
      .getTicketType(this.event?.id ?? 0)
      .subscribe((resp: ResponseTicketTypeOrGroupedByDate) => {
        this.ticketTypeList = resp;
      });

    if (this.event?.id) {
      const startAt = this.event?.startAt.toString();
      if (startAt) {
        this.soonerTTDate = startAt;
      }

      lastValueFrom(
        this.analyticsService.logEventVisit({
          data: {
            type: 'event',
            item_id: this.event.id,
            source: this.getSource(),
          },
        })
      );
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();

    this.metaPixelService.removeScript();
    this.gtmService.removeScript();
    this.refreshSubscription?.unsubscribe();
  }

  private setProducts() {
    this.products = [];
    Object.values(this.ticketTypeList).forEach((tt: TicketType) => {
      this.products.push({
        ticket_type_id: tt.id,
        qty: 0,
        seats: [],
      });
    });
  }

  private flatIfIsGroupedByDate() {
    const isGroupedByDate = !Array.isArray(this.ticketTypeList);
    let list: TicketType[];

    if (isGroupedByDate) {
      list = Object.values(this.ticketTypeList).flat();
    } else {
      list = this.ticketTypeList as TicketType[];
    }

    return list;
  }

  private async refreshTicketTypes() {
    if (this.proceeding) return;

    this.loadingComponent.toggle('Refrescando disponibilidad de tickets');

    await new Promise((resolve, reject) => {
      setTimeout(resolve, 1000);
    });

    this.eventService.ticketService
      .getTicketType(this.event?.id ?? 0)
      .subscribe((resp: ResponseTicketTypeOrGroupedByDate) => {
        this.loadingComponent.toggle();

        this.ticketTypeList = resp;

        this.selectedTicketTypeList.forEach((tt) => {
          const ticketType = this.flatIfIsGroupedByDate().find(
            (t) => t.id == tt.id
          );

          const used = JSON.parse(JSON.stringify(tt.tickets)).filter(
            (t: any) => t.status == 'used'
          );

          const available = JSON.parse(
            JSON.stringify(ticketType!.tickets)
          ).filter((t: any) => t.status == 'available');

          const usedLength =
            available.length >= used.length ? used.length : available.length;

          for (let i = 0; i < usedLength; i++) {
            let usedTicket = used[i];

            let index = 0;

            if (ticketType!.isSeat) {
              index = ticketType!.tickets.findIndex(
                (t) =>
                  t.id == usedTicket.id && t.status == TicketStatus.AVAILABLE
              );
            } else {
              index = ticketType!.tickets.findIndex(
                (t) => t.status == TicketStatus.AVAILABLE
              );
            }

            if (index != -1) ticketType!.tickets[index] = usedTicket;
          }
        });
      });
  }

  onProductChangeListener(product: Product) {
    if (!this.isOpenTicketsSelection) return;

    const index = this.products.findIndex(
      (p) => p.ticket_type_id === product.ticket_type_id
    );

    if (index === -1 && product.qty >= 1) {
      this.products.push(product);
    } else if (product.qty <= 0) {
      this.products.splice(index, 1);
    } else {
      this.products[index] = product;
    }

    this.calcTotalAmount();
  }

  get disabledToCheckout() {
    return !this.products.some((p) => p.qty > 0);
  }

  async proceedToCheckout(email?: string): Promise<void> {
    this.proceeding = true;
    this.isOpenTicketsSelection = false;

    const products = this.products.filter((p) => p.qty > 0);
    if (products.length === 0 || !this.event?.id) {
      this.isOpenTicketsSelection = true;
      return;
    }

    // Check for donation ticket
    const donationProduct = products.find((p) => {
      const tt = this.getTicketTypeById(p.ticket_type_id);
      const minDonation = Number(tt?.min_donation_amount || 0);
      return minDonation > 0;
    });

    if (
      donationProduct &&
      !donationProduct.donation_amount_per_ticket &&
      !email
    ) {
      const tt = this.getTicketTypeById(donationProduct.ticket_type_id);
      if (tt) {
        this.donationTicketType = tt;
        this.initialDonationQty = donationProduct.qty;
        this.showDonationModal = true;
        this.proceeding = false;
        return;
      }
    }

    try {
      await new Promise((resolve, rej) => {
        setTimeout(() => {
          resolve('');
        }, 1000);
      });

      const session = await this.checkoutSessionService.startSession(
        this.event.id,
        products,
        email
      );

      const saved = this.saveState(session, products);
      if (!saved) {
        this.isOpenTicketsSelection = true;
        return;
      }

      this.closeEmailForm();
      this.router.navigate([`/order/checkout/${this.event?.slug}`]);

      // START THE TIMER FOR CHECKOUT SESSION
      this.utilService.startTimer(() => {}, true);
    } catch (error: any) {
      const whitelist = error.error?.error?.details?.whitelist;
      if (whitelist) {
        if (!email) {
          this.openEmailForm();
        } else {
          Swal.fire({
            title: `Restringido`,
            html: `
            <div>
            <p>
            Este correo no se encuentra habilitado para comprar en este evento.
              </p>
            </div>`,
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        }
        return;
      }
      this.handleCheckoutSessionErrors(error);
      return;
    } finally {
      this.proceeding = false;
    }
  }

  private handleCheckoutSessionErrors(error: any) {
    const checkoutError = error?.error?.error
      ?.details as CheckoutSessionErrorResponse;
    switch (checkoutError.code) {
      case CheckoutSessionCode.CHECKOUT_INVALID_TICKET_TYPE:
        alert('Algunos de los tipos de tickets seleccionados ya no existen.');
        break;
      case CheckoutSessionCode.CHECKOUT_INVALID_TICKET_TYPE_QTY:
        alert(
          'La cantidad de tickets solicitada no es válida o supera el límite disponible.'
        );
        break;
      case CheckoutSessionCode.CHECKOUT_INVALID_TICKET_TYPE_SEAT:
        alert('Uno o más asientos seleccionados ya no están disponibles.');
        break;
      default:
        alert('Ha ocurrido un error inesperado. Intenta nuevamente.');
        break;
    }
  }

  private getSelectedTicketTypes() {
    let selectedTicketTypes: TicketType[];
    const ticketTypesIds = this.products.map((p) => p.ticket_type_id);
    const findCB = (tt: TicketType) => ticketTypesIds.includes(tt.id);
    if (Array.isArray(this.ticketTypeList)) {
      selectedTicketTypes = this.ticketTypeList.filter(findCB);
    } else {
      const list = Object.values(this.ticketTypeList).flat();
      selectedTicketTypes = list.filter(findCB);
    }

    return selectedTicketTypes;
  }

  private saveState(
    session: CheckoutSessionStartResponse,
    products: Product[]
  ) {
    console.log('SAVING PRODUCTS', products);
    const selectedTicketTypes = this.getSelectedTicketTypes();
    const promoterSlug = this.route.snapshot.queryParamMap.get('promoter');
    const sessionData = {
      sessionToken: session.data.session_token,
      products,
      selectedTicketTypes,
      event: this.event,
      promoterSlug: promoterSlug || '',
    };

    sessionStorage.setItem(
      Constants.Keys.CheckoutSession,
      JSON.stringify(sessionData)
    );
    return true;
  }

  private calcTotalAmount() {
    this.totalAmount = 0;
    this.products.forEach((product) => {
      const { qty, ticket_type_id } = product;
      const tt = this.getTicketTypeById(ticket_type_id);

      if (product.donation_amount_per_ticket) {
        this.totalAmount += product.donation_amount_per_ticket * qty;
      } else if (tt && tt.min_donation_amount) {
        this.totalAmount += Number(tt.min_donation_amount) * qty;
      } else {
        this.totalAmount += this.calcAmount(qty, tt);
      }
    });
  }

  private getTicketTypeById(id: number): TicketType | undefined {
    if (Array.isArray(this.ticketTypeList)) {
      return this.ticketTypeList.find((t) => t.id === id);
    } else {
      const list = Object.values(this.ticketTypeList).flat();
      return list.find((t) => t.id === id);
    }
  }

  onDonationConfirm(data: { qty: number; amount: number }) {
    this.showDonationModal = false;
    if (this.donationTicketType) {
      const product = this.products.find(
        (p) => p.ticket_type_id === this.donationTicketType!.id
      );
      if (product) {
        product.qty = data.qty;
        product.donation_amount_per_ticket = data.amount;
        this.calcTotalAmount();
        // Proceed to checkout (or email form if needed)
        this.proceedToCheckout();
      }
    }
  }

  closeDonationModal() {
    this.showDonationModal = false;
    this.isOpenTicketsSelection = true;
    this.proceeding = false;
  }

  private calcAmount(qty: number, tt?: TicketType) {
    if (!tt) return 0;
    return tt.price * qty;
  }

  getMapEventImageUrl(mapImage: string): string {
    return this.utilService.getAbsoluteUrl(mapImage);
  }

  private getBanners(): Banner[] {
    const banners = this.event?.cover.map((cover) => {
      return {
        imageUri: cover.attributes.url ?? '',
        active: true,
        description: null,
        endAt: null,
        id: 0,
        link: null,
        priority: 0,
        startAt: null,
        title: '',
      };
    });

    return banners as Banner[];
  }

  closeMap() {
    this.isOpen = false;
  }

  openMap() {
    const list = Object.values(this.ticketTypeList);
    const has3dMap = list.flat().some((tt: any) => tt.block_id);
    if (has3dMap) {
      this.isOpen = true;
    } else {
      new Fancybox([
        {
          src: this.getMapEventImageUrl(this.event?.mapImageUri ?? ''),
        },
      ]);
    }
  }

  private getSource() {
    const ref = document.referrer;

    if (ref.includes('instagram')) {
      return 'instagram';
    } else if (ref.includes('facebook')) {
      return 'facebook';
    } else if (ref.includes('google')) {
      return 'google';
    } else {
      return '';
    }
  }
}
